let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1sxE9")).then(() => parcelRequire('4oHMI'));